

import { Component, Vue } from 'vue-property-decorator';

import { UserModule } from '~/store/modules/user';

import ContainerConsents from '~/components/User/Consents/MarketingConsents/ContainerConsents.vue';

@Component({
    components: {
        ContainerConsents
    },
})
export default class MarketingConsents extends Vue {

    get userInterest() {
        return UserModule.interestsMarketingConsents;
    }

    get userChannels() {
        return UserModule.channelsMarketingConsents;
    }

}
